import React from 'react';
import AddAndEditTransporterDriverForm from './AddAndEditTransporterDriverForm';

/* React functional component */
const CreateTransporterDriverScreen = () => {
  return <AddAndEditTransporterDriverForm mode="add" />;
};

export default CreateTransporterDriverScreen;
